import { ChangeDetectionStrategy, Component, SecurityContext } from '@angular/core';
import { AnyInnerSection, Section, SectionAttributes } from '../../../app/types/section';
import { SectionComponent } from '../../components/section/section.component';


import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { DEFAULT_ATTRIBUTE_ALLOWLIST, HtmlComponent } from '@knorr-bremse-portals/ngx-components/components/html';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

export interface CopyTextAttributes extends SectionAttributes {
  numColumns: 12 | 8;
  content: string;
}

type CopyTextEditorIds = [
  'numColumns',
  'content',
]

export type CopyTextSection = Section<CopyTextAttributes, CopyTextEditorIds, 'copy-text'>;

export function isCopyTextSection(section: AnyInnerSection): section is CopyTextSection {
  return section.component === 'copy-text';
}

@Component({
    selector: 'app-copy-text',
    styleUrls: ['./copy-text.component.scss'],
    templateUrl: './copy-text.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        EditorIdDirective,
        HtmlComponent,
        FsButtonComponent,
    ],
    host: {
      'kb-section': '',
    },
})
export class CopyTextComponent extends SectionComponent<CopyTextSection> {

  protected attributeAllowlist = {
    'class': SecurityContext.NONE,
    ...DEFAULT_ATTRIBUTE_ALLOWLIST,
  };
}
